import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const closeFullScreenAiPhotoGeneration = () => closePopupHelper(popupNames.FULLSCREEN_AI_GENERATION_IMAGE);

export const renderFullScreenAiPhotoGeneration = () => {
    openPopupHelper({
        popupName: popupNames.FULLSCREEN_AI_GENERATION_IMAGE,
        onClose: closeFullScreenAiPhotoGeneration,
    });
};
